import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { useNotificationStore } from "store/notificationStore";
import NotificationCard from "./NotificationCard";

const AUTO_DISMISS_MS = 6000;

function NotificationToast({ onNotificationClick }) {
  const activeToast = useNotificationStore((state) => state.activeToast);
  const dismissToast = useNotificationStore((state) => state.dismissToast);

  if (!activeToast) return null;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    dismissToast();
  };

  const handleCardClick = (notification) => {
    onNotificationClick(notification);
    dismissToast();
  };

  return (
    <Snackbar
      open={Boolean(activeToast)}
      autoHideDuration={AUTO_DISMISS_MS}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      className="mod-notification-toast"
    >
      <NotificationCard
        variant="toast"
        notification={activeToast}
        isUnread
        heading="New Notification"
        onClick={handleCardClick}
        onClose={dismissToast}
      />
    </Snackbar>
  );
}

export default NotificationToast;
